const postToWebView = (type, payload = {}) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type,
        ...payload
      })
    )
    return true
  }
  return false
}

export default postToWebView
